<div class="row">
  <div class=" col-auto me-0 pe-0">


    <i class="e"></i>
    <i
      class="me-2"
      [ngClass]="{
      'ri-megaphone-fill text-danger ri-1x ':!this.helpRequest().solved,
      'ri-megaphone-line text-primary ':this.helpRequest().solved
    }"
    ></i>


  </div>
  <div
    class="col ms-0 ps-0"
    [ngClass]="{
      'text-danger ':!this.helpRequest().solved,
      'text-primary ':this.helpRequest().solved
    }"
  >
    {{this.helpRequest().name}}


  </div>
  <div class="col-auto ">

    <i
      (click)="this.toggleReadNotification()"
      [ngClass]="{
      'ri-checkbox-blank-line  cursor-pointer ':!this.helpRequest().solved,
      'ri-checkbox-line ':this.helpRequest().solved
      }"
    ></i>

  </div>
</div>
